import React from 'react';
import styles from './RegistrationInfoPane.module.css';

const RegistrationInfoPane = () => {
   return (
      <section className={styles.wrapper}>
         <div className={styles.section}>
            <div className={styles.sectionHeading}>WORKSHOPS - Free to participate.</div>
            <ul className={styles.sectionList}>
               <li className={styles.sectionListItem}>
                  IoT Unleashed: Bringing Intelligence to Your Fingertips <b>(Hands-on)</b>
               </li>
            </ul>
            <ul className={styles.sectionList}>
               <li className={styles.sectionListItem}>
                  Automotive powertrain: Automobile transmission systems and sensors <b>(Hands-on)</b>
               </li>
            </ul>
         </div>
         <div className={styles.section}>
            <div className={styles.sectionHeading}>
               EVENTS - <b>Free to participate!</b>
            </div>
            <ul className={styles.sectionList}>
               <li className={styles.sectionListItem}>
                  Decrypt dash - Decrypt dash is a game based on engineering themes, principles, technical words, and universally acknowledged facts designed to test your vocabulary, creativity, and quick thinking as you link one clue to another. There will be two rounds. Candidates will be shortlisted from round 1 and go on to round 2.
               </li>
            </ul>
         </div>
         {/* <a href="/upi.jpg" target='__blank'>
            <button className={styles.infoDocButton}>
               <div className={styles.infoDocName}>
                  <span>&nbsp;Show UPI QR for Payment</span>
               </div>
            </button>
         </a> */}
      </section>
   );
};

export default RegistrationInfoPane;

